import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles({
  container: {
    width: 125,
    height: 48,
  },

  label: {
    textTransform: 'capitalize',
  },

  failed: {
    color: '#FF3D3D',
    borderColor: '#FF3D3D',
    '&:hover': {
      color: '#FF3D3D',
      borderColor: '#FF3D3D',
    },
  },
  processing: {
    color: '#1921FA',
    borderColor: '#1921FA',
    '&:hover': {
      color: '#1921FA',
      borderColor: '#1921FA',
    },
  },
  success: {
    color: '#3CD860',
    borderColor: '#3CD860',
    '&:hover': {
      color: '#3CD860',
      borderColor: '#3CD860',
    },
  },
});
